import React, { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export const Spinner = ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            className={cn(
                'inline-block size-6 animate-spin rounded-full border-4 border-gray-200 !border-t-current',
                className,
            )}
            role='status'
            aria-label='loading'
            {...props}>
            {children}
            {/* TODO: replace hardcoded string */}
            <span className='sr-only'>Loading...</span>
        </div>
    );
};
